import axios from "axios";
import { cleanHeaders } from "../clean-headers";

const getSubgenre = async (params) => {
  const headers = cleanHeaders(params);

  try {
    return await axios.get(
        "https://music.videomite.tech/api/subgenre",
        {headers}
    ).then((res) => res.data);
  } catch (error) {
    console.log(error);
  }
};

export { getSubgenre };
